import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPin2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconPin2"><Path d="M17 8.75781C18.8263 10.2224 20 12.4732 20 15V16H13V20L12 22L11 20V16H4V15C4 12.4732 5.17366 10.2224 7 8.75781V2H17V8.75781Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPin2;
